import { Avatar, Row, Tag } from 'antd'
import { D4_Lot_Coproprietaire, Maybe } from '../../types'
import D4Avatar from '../D4Avatar'

const Equipe = ({ lots }: { lots: Maybe<D4_Lot_Coproprietaire[]> | undefined }) => {
  if (!lots) return null

  return (
    <Row>
      {lots.map((lot) => {
        const gestionnaireNom = lot.lot?.copropriete?.gestionnaire?.nom
        const comptableNom = lot.lot?.copropriete?.comptable?.nom
        const sedentaireNom = lot.lot?.copropriete?.gestionnaireSedentaire?.nom

        const gestionnairePrenom = lot.lot?.copropriete?.gestionnaire?.prenom
        const comptablePrenom = lot.lot?.copropriete?.comptable?.prenom
        const sedentairePrenom = lot.lot?.copropriete?.gestionnaireSedentaire?.prenom

        return (
          <Row align="middle" key={lot.lot?.id}>
            <Tag>{lot.lot?.copropriete?.trigramme}</Tag>
            <Avatar.Group>
              <D4Avatar role="comptable" nom={comptableNom} prenom={comptablePrenom} />
              <D4Avatar role="gestionnaire" nom={gestionnaireNom} prenom={gestionnairePrenom} />
              <D4Avatar role="gestionnaire-sedentaire" nom={sedentaireNom} prenom={sedentairePrenom} />
            </Avatar.Group>
          </Row>
        )
      })}
    </Row>
  )
}

export default Equipe
